import { useRequiredParams } from 'utils';

import { useReportingAccounts } from './useReportingAccounts';
import { useReportingDateRange } from './useReportingDateRange';
import { useReportingIncludeClosed } from './useReportingIncludeClosed';

// The one definition of a reporting tab's read scope: the household from the route plus the
// URL-backed date range, account selection and closed-account toggle shared across the reporting
// tabs. Tabs read their filters here; ReportingHeader owns the setters via the underlying hooks.
export const useReportingScope = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);
    const { dateRange } = useReportingDateRange();
    const { selectedAccountGUIDs } = useReportingAccounts();
    const { includeClosed } = useReportingIncludeClosed();

    return { householdGUID: globalAccountGUID, dateRange, selectedAccountGUIDs, includeClosed };
};
